"use client"

import { useEffect } from "react"
import ReactPlayer from "react-player"
import Video from "../../videos/tour.mp4"

const VideoModal = ({ isOpen, onClose }) => {
  // Disable scrolling when the modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }

    // Clean up the effect when the modal is closed or the component is unmounted
    return () => {
      document.body.style.overflow = ""
    }
  }, [isOpen])

  if (!isOpen) return null

  // Handler to close the modal when clicking outside the video
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="fixed top-4 right-4 text-4xl text-white hover:text-gray-400 z-60"
        aria-label="Close"
      >
        &times;
      </button>
      <div className="relative w-[95%] lg:w-[80%] h-[50%] lg:h-[85%]">
        {/* Video Element */}
        <ReactPlayer
          url={Video}
          width="100%"
          height="100%"
          playing
          controls
          config={{
            file: {
              attributes: {
                crossOrigin: "anonymous",
              },
            },
          }}
        />
      </div>
    </div>
  )
}

export default VideoModal
